import { Typography, Box } from '@mui/material'
import React from 'react'

function Footer() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return (
        <>
            {/* <Box component={'footer'} sx={{ padding: { xs: 2, md: 3 } }} mt={2}>
                <Typography sx={{ color: '#989898', textAlign: 'center', fontWeight: 700 }}>&copy;{currentYear} IFAC-X. All rights reserved</Typography>
            </Box> */}
        </>
    )
}

export default Footer